import React from "react";
import desbanner from "../../assets/destination-banner.jpg"
import indiagate from "../../assets/destination_images/indiagate.jfif"
import banglore from "../../assets/destination_images/bangalore.jfif"
import amerfort from "../../assets/destination_images/amer.jfif"
import kolkata from "../../assets/destination_images/kolkata.jfif"
import varanashi from "../../assets/destination_images/varanasi.jpeg"
import rishikesh from "../../assets/destination_images/rishikesh.jpeg"
import badrinath from "../../assets/destination_images/badrinath.jpeg"
import kedarnath from "../../assets/destination_images/Kedarnath temple.jpeg"
import jagannathpuri from "../../assets/destination_images/jagannath puri.jpeg"
import statueofunity from "../../assets/destination_images/statue of unity.jfif"
import ladakh from "../../assets/destination_images/ladakh.jfif"
import manali from "../../assets/destination_images/manali.jfif"
import goa from "../../assets/destination_images/goa.jfif"
import tajmahal from "../../assets/destination_images/tajmahal.jfif"
import sikkim from "../../assets/destination_images/sikkim.jfif"
import amritsar from "../../assets/destination_images/golden temple.jpeg"
import kanchanjangha from "../../assets/destination_images/Kanchanjangha Mountain.jfif"
import premmandir from "../../assets/destination_images/Prem Mandir.jpeg"
import dzukouvalley from "../../assets/destination_images/Dzukou Valley.jfif"
import lakshadweep from "../../assets/destination_images/lakshwadeep.jpg"
import punducherry from "../../assets/destination_images/punducherry.jfif"
import munnar from "../../assets/destination_images/munnar.jfif"
import ooty from "../../assets/destination_images/ooty.jpg"
import udaipur from "../../assets/destination_images/udaipur.jfif"
import andaman from "../../assets/destination_images/Andaman.jfif"
import shimla from "../../assets/destination_images/shimla.jfif"
import lehladakh from "../../assets/destination_images/leh ladakh.jfif"
import akshardham from "../../assets/destination_images/akshardham.jfif"
import "../destinations/Destinations.css"

const Destinations = () => {
  return (
    <>
        <section className="banner">
          <div className="about-banner">
            <img src={desbanner} alt="" />
          </div>
          <div className="abc12">
            <p className="dest-fade">Destinations</p>
            <p className="desti-banner-text">Explore the beauty</p>
          </div>
        </section>
        <section className="whole">
          <div className="container">
            <div className="imagica ">
              <div className="ok">
                <div className="img">
                  <img src={indiagate} alt="" />
                </div>
                <div className="cen">India Gate</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={banglore} alt="" />
                </div>
                <div className="cen">Banglore</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={amerfort} alt="" />
                </div>
                <div className="cen">Amer fort</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={kolkata} alt="" />
                </div>
                <div className="cen">Kolkata</div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="imagica ">
              <div className="ok">
                <div className="img">
                  <img src={varanashi} alt="" />
                </div>
                <div className="cen">Varanashi</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={rishikesh} alt="" />
                </div>
                <div className="cen">Rishikesh</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={badrinath} alt="" />
                </div>
                <div className="cen">Badrinath</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={kedarnath} alt="" />
                </div>
                <div className="cen">Kedarnath </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="imagica ">
              <div className="ok">
                <div className="img">
                  <img src={jagannathpuri} alt="" />
                </div>
                <div className="cen">Jagannath<br/> Puri</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={statueofunity} alt="" />
                </div>
                <div className="cen">Statue of<br/> unity</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={ladakh} alt="" />
                </div>
                <div className="cen">Ladakh</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={manali} alt="" />
                </div>
                <div className="cen">Manali</div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="imagica ">
              <div className="ok">
                <div className="img">
                  <img src={goa} alt="" />
                </div>
                <div className="cen"> Goa</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={tajmahal} alt="" />
                </div>
                <div className="cen">Taj Mahal</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={sikkim} alt="" />
                </div>
                <div className="cen">Sikkim</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={amritsar} alt="" />
                </div>
                <div className="cen">Amritsar</div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="imagica ">
              <div className="ok">
                <div className="img">
                  <img src={kanchanjangha} alt="" />
                </div>
                <div className="cen"> Kanchanjangha </div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={premmandir} alt="" />
                </div>
                <div className="cen">Prem Mandir</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={dzukouvalley} alt="" />
                </div>
                <div className="cen">Dzukou Valley</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={lakshadweep} alt=""/>
                </div>
                <div className="cen">Lakshadweep</div>
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="imagica  ">
              <div className="ok">
                <div className="img">
                  <img src={punducherry} alt=""/>
                </div>
                <div className="cen"> Puducherry </div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={munnar} alt="" />
                </div>
                <div className="cen">Munnar</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={ooty} alt="" />
                </div>
                <div className="cen">Ooty</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={udaipur} alt="" />
                </div>
                <div className="cen">udaipur</div>
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="imagica  ">
              <div className="ok">
                <div className="img">
                  <img src={andaman} alt="" />
                </div>
                <div className="cen"> Andaman </div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={shimla} alt=""/>
                </div>
                <div className="cen"> Shimla </div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={lehladakh} alt="" />
                </div>
                <div className="cen">Leh Ladakh</div>
              </div>

              <div className="ok">
                <div className="img">
                  <img src={akshardham} alt="" />
                </div>
                <div className="cen">Akshardham</div>
              </div>
            </div>
          </div>
        </section>
      {/* </div> */}
    </>
  );
};

export default Destinations;
